import { FC, useCallback } from 'react';
import { useForm } from 'react-final-form';

import { Button } from '@beeline/design-system-react/extracted-styles';

import { Panel } from 'src/components/Panel/Panel';
import { bookingsActions } from 'src/store/bookings/slice';
import { BookingsPageRole } from 'src/store/bookings/types';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import {
  MyBookingsPageRoleProvider,
  useMyBookingsPageRole,
} from '../../MyBookingsPageRole/MyBookingsPageRoleProvider';

import { MyBookingsFiltersFields } from './MyBookingsFiltersFields';
import { MyBookingsFiltersForm } from './MyBookingsFiltersForm';

const Actions: FC = () => {
  const dispatch = useAppDispatch();
  const { setRole } = useMyBookingsPageRole();
  const { submit } = useForm();

  const applyFilters = useCallback(async () => {
    await submit();
    dispatch(sidesheetActions.close());
  }, [dispatch, submit]);

  const resetFilters = useCallback(() => {
    dispatch(bookingsActions.resetFilters());
    setRole(BookingsPageRole.Responsible);
    dispatch(sidesheetActions.close());
  }, [dispatch, setRole]);

  return (
    <>
      <Button
        variant='outlined'
        onClick={resetFilters}
        data-testid='resetMyBookingsFilters'
      >
        Сбросить
      </Button>
      <Button
        variant='contained'
        onClick={applyFilters}
        data-testid='applyMyBookingsFilters'
      >
        Применить
      </Button>
    </>
  );
};

export const MyBookingsFiltersSidesheetPanel: FC = () => {
  return (
    <MyBookingsPageRoleProvider>
      <MyBookingsFiltersForm>
        <Panel actions={<Actions />}>
          <MyBookingsFiltersFields />
        </Panel>
      </MyBookingsFiltersForm>
    </MyBookingsPageRoleProvider>
  );
};
